import { render, staticRenderFns } from "./MainHomepage.vue?vue&type=template&id=2b32078c&scoped=true"
import script from "./MainHomepage.vue?vue&type=script&lang=js"
export * from "./MainHomepage.vue?vue&type=script&lang=js"
import style0 from "./MainHomepage.vue?vue&type=style&index=0&id=2b32078c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b32078c",
  null
  
)

export default component.exports